import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { CrossedOutPrice, PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ResponsivePrice = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplayComponents__ResponsivePrice",
  componentId: "fsjwth-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-700'], {
    [trellisBreakpoint.tablet]: Object.assign({}, theme.typography['heading-800'])
  });
});
const BillingTermText = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplayComponents__BillingTermText",
  componentId: "fsjwth-1"
})(({
  theme
}) => Object.assign({
  display: 'block',
  marginTop: theme.space[300],
  marginBottom: theme.space[100],
  color: theme.color['text-core-default']
}, theme.typography['heading-300']));
const BillingTermSubtext = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplayComponents__BillingTermSubtext",
  componentId: "fsjwth-2"
})(({
  theme
}) => Object.assign({
  display: 'block'
}, theme.typography['body-100'], {
  color: theme.color['text-core-default']
}));
const StyledPricePerYearText = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplayComponents__StyledPricePerYearText",
  componentId: "fsjwth-3"
})(({
  theme
}) => ({
  color: theme.color['fill-positive-default']
}));
export const MonthlyPriceDisplay = ({
  price,
  currencyCode,
  annualListPrice,
  annualCostPrice
}) => /*#__PURE__*/_jsx(ResponsivePrice, {
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "planBuilder.priceDisplay.pricePerMonthShort",
    options: {
      price: /*#__PURE__*/_jsx(PriceDisplay, {
        price: price,
        currencyCode: currencyCode,
        dataSelenium: "plan-builder-monthly-price",
        dataDiscounted: annualListPrice > annualCostPrice
      })
    }
  })
});
const YearlyPriceDisplay = ({
  currencyCode,
  annualCostPrice,
  showCostToGetStarted
}) => /*#__PURE__*/_jsx(StyledPricePerYearText, {
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "planBuilder.priceDisplay.pricePerYear",
    options: {
      price: /*#__PURE__*/_jsx(PriceDisplay, {
        price: annualCostPrice,
        currencyCode: currencyCode,
        dataSelenium: !showCostToGetStarted ? 'plan-builder-total-price' : undefined
      })
    }
  })
});
export const AnnualBillingTermTextComponent = ({
  annualListPrice,
  annualCostPrice,
  currencyCode,
  showCostToGetStarted
}) => {
  const showCrossedOutPrice = annualListPrice !== annualCostPrice;
  if (showCrossedOutPrice) {
    return /*#__PURE__*/_jsx(BillingTermText, {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "planBuilder.priceDisplay.annualBillingTermTextDiscounted",
        options: {
          crossedOutPrice: /*#__PURE__*/_jsx(CrossedOutPrice, {
            price: annualListPrice,
            currencyCode: currencyCode
          }),
          price: /*#__PURE__*/_jsx(YearlyPriceDisplay, {
            annualCostPrice: annualCostPrice,
            currencyCode: currencyCode,
            showCostToGetStarted: showCostToGetStarted
          })
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(BillingTermText, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "planBuilder.priceDisplay.annualBillingTermText",
      options: {
        price: /*#__PURE__*/_jsx(YearlyPriceDisplay, {
          annualCostPrice: annualCostPrice,
          currencyCode: currencyCode,
          showCostToGetStarted: showCostToGetStarted
        })
      }
    })
  });
};
export const BillingTermSubtextComponent = ({
  term,
  hasPrice
}) => {
  if (!term || !hasPrice) return null;
  return /*#__PURE__*/_jsx(BillingTermSubtext, {
    children: term === MONTHLY ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.priceDisplay.billingTermMonthlySubtext"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.priceDisplay.billingTermAnnualSubtext"
    })
  });
};
export const CostToGetStartedSection = ({
  costToGetStarted,
  currencyCode,
  showTotalPriceAsterisk
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "body-125",
    paddingInline: "500",
    marginBlockStart: "500",
    marginBlockEnd: "100",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.priceDisplay.estimatedCost"
    })
  }), /*#__PURE__*/_jsxs(Text, {
    typography: "body-300",
    children: [/*#__PURE__*/_jsx(PriceDisplay, {
      currencyCode: currencyCode,
      price: costToGetStarted,
      "data-selenium-id": "plan-builder-total-price"
    }), showTotalPriceAsterisk && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.requiredOnboardingSubtext.asterisk"
    })]
  })]
});